import { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowLeft, PaperPlaneRight } from "@phosphor-icons/react";

const BookingChat = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [booking, setBooking] = useState(null);

  const load = useCallback(() => {
    api.get(`/bookings/${id}/messages`).then((r) => setMessages(r.data)).catch(() => {});
  }, [id]);

  useEffect(() => {
    if (!loading && !user) { navigate("/login"); return; }
    if (user) {
      api.get(`/bookings/${id}`).then((r) => setBooking(r.data)).catch(() => {});
      load();
      const t = setInterval(load, 3000);
      return () => clearInterval(t);
    }
  }, [user, loading, id, navigate, load]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    const t = text;
    setText("");
    await api.post(`/bookings/${id}/messages`, { text: t });
    load();
  };

  if (!user) return null;

  return (
    <div className="max-w-2xl mx-auto px-4 py-6 flex flex-col h-[calc(100vh-4rem)]">
      <div className="flex items-center gap-3 pb-3 border-b">
        <Button variant="ghost" size="icon" onClick={() => navigate(-1)} data-testid="chat-back"><ArrowLeft /></Button>
        <div>
          <h1 className="font-heading font-semibold">{booking?.service_name}</h1>
          <p className="text-xs text-muted-foreground">{booking ? `${booking.date} · ${booking.start_time}` : ""}</p>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto py-4 space-y-3" data-testid="chat-messages">
        {messages.length === 0 && <p className="text-center text-sm text-muted-foreground py-10">Inizia la conversazione, scambia foto e dettagli.</p>}
        {messages.map((m) => {
          const mine = m.sender_id === user.user_id;
          return (
            <div key={m.message_id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[75%] rounded-2xl px-4 py-2 ${mine ? "bg-primary text-primary-foreground rounded-br-sm" : "bg-secondary rounded-bl-sm"}`}>
                {!mine && <div className="text-[11px] opacity-70 mb-0.5">{m.sender_name}</div>}
                <div className="text-sm">{m.text}</div>
              </div>
            </div>
          );
        })}
      </div>

      <form onSubmit={send} className="flex gap-2 pt-3 border-t">
        <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="Scrivi un messaggio…" data-testid="chat-input" className="rounded-full" />
        <Button type="submit" size="icon" className="rounded-full shrink-0" data-testid="chat-send"><PaperPlaneRight weight="fill" /></Button>
      </form>
    </div>
  );
};

export default BookingChat;
